import { Component, computed, input, OnInit, output, signal } from '@angular/core';
import {
  RidAssessmentToast,
  RidContentCard,
  RidMechanicBackground,
  RidMechanicContent,
  RidMechanicTitle,
  RidMechanicWrapper,
  RidTopBar,
} from '../../components';
import { delay } from '@gametailors/web-core/misc';
import { AudioEffectPlayer } from '../../utils/audio.utils';

@Component({
  selector: 'rid-splitting',
  templateUrl: './rid-splitting.html',
  imports: [RidMechanicBackground, RidMechanicWrapper, RidTopBar, RidMechanicContent, RidAssessmentToast, RidContentCard, RidMechanicTitle],
  host: {
    class: 'block',
  },
})
export class RidSplitting implements OnInit {
  numbers = input.required<[number, number][]>();
  visibilityDuration = input(3500);

  index = signal(0);
  pair = computed(() => this.numbers()[this.index()]);
  state = signal<'VISIBLE' | 'ANSWER'>('VISIBLE');

  finished = output<void>();

  async ngOnInit() {
    await this.initialize();
  }

  async next() {
    const isLastIndex = this.index() === this.numbers().length - 1;

    if (isLastIndex) {
      this.finished.emit();
    } else {
      this.state.set('VISIBLE');
      this.index.set(this.index() + 1);
      await this.initialize();
    }
  }

  async initialize() {
    await delay(this.visibilityDuration());
    this.state.set('ANSWER');
  }

  markCorrect() {
    AudioEffectPlayer.play('CORRECT');
    return this.next();
  }

  markIncorrect() {
    AudioEffectPlayer.play('INCORRECT');
    return this.next();
  }
}
